<template>
  <div class="completed">
    <div v-if="!isReviewingQuestions" class="completed__success-wrapper">
      <div class="completed__icon-wrapper">
        <SpacemanIcon v-if="isQuizPassed" class="completed__spaceman-icon" />
        <AliensIcon v-else class="completed__aliens-icon" />
      </div>
      <div class="completed__scorecard">
        <div
          class="completed__title"
          :class="
            isQuizPassed
              ? 'completed__title--passed'
              : 'completed__title--failed'
          "
        >
          {{ title }}
        </div>
        <div class="completed__was-successful">{{ copy }}</div>
        <div class="completed__scores">
          <div class="completed__score">
            <figure class="completed__score--circle">
              <span class="completed__score--correct">{{ correct }}</span>
            </figure>
            <p class="completed__score--text">Correct</p>
          </div>
          <div class="completed__score">
            <figure class="completed__score--circle">
              <span class="completed__score--incorrect">{{ incorrect }}</span>
            </figure>
            <p class="completed__score--text">Incorrect</p>
            <button
              v-show="incorrect > 0"
              @click="toggleReviewQuestions()"
              class="completed__review-questions-btn"
            >
              Review Questions
            </button>
          </div>
        </div>
      </div>
      <div class="completed__retry-wrapper">
        <p class="completed__retry-text">Retry Quiz</p>
        <button class="completed__retry-btn" @click="restartQuiz()">
          <RetryIcon class="completed__retry-btn--icon" />
        </button>
      </div>
    </div>
    <ReviewQuestions
      v-if="isReviewingQuestions"
      key="quiz-modal--review-questions"
      class="completed__review-questions"
      :missedQuestions="missedQuestions"
      @closeReviewQuestions="toggleReviewQuestions"
    />
    <NextVideo class="completed__next-video" :nextVideo="nextVideo" />
  </div>
</template>

<script>
import SpacemanIcon from '@/assets/icons/course/quiz/spaceman.svg'
import AliensIcon from '@/assets/icons/course/quiz/aliens.svg'
import RetryIcon from '@/assets/icons/course/quiz/retry.svg'
import ReviewQuestions from '@/components/course/content/level/quiz-modal/completed/ReviewQuestions.vue'
import NextVideo from '@/components/course/content/level/quiz-modal/completed/NextVideo.vue'

export default {
  name: 'Completed',
  components: {
    SpacemanIcon: { ...SpacemanIcon, name: 'SpacemanIcon' },
    AliensIcon: { ...AliensIcon, name: 'AliensIcon' },
    RetryIcon: { ...RetryIcon, name: 'RetryIcon' },
    ReviewQuestions,
    NextVideo,
  },
  data() {
    return {
      isReviewingQuestions: false,
    }
  },
  props: {
    isQuizPassed: {
      type: Boolean,
      required: true,
    },
    finalTime: {
      type: String,
      required: false,
    },
    finalScore: {
      type: Object,
      required: true,
    },
    nextVideo: {
      type: Object,
      required: false,
    },
  },
  computed: {
    title() {
      return this.isQuizPassed ? 'Congrats' : 'Nice Try'
    },
    copy() {
      return this.isQuizPassed
        ? 'You Passed the Quiz!'
        : 'You Didn’t Pass this Quiz… yet!'
    },
    incorrect() {
      const { incorrect } = this.finalScore
      return incorrect.length
    },
    correct() {
      const { correct } = this.finalScore
      return correct.length
    },
    incorrectAnswerIds() {
      const incorrectAnswerIds = []
      this.finalScore.incorrect.map(answer => {
        incorrectAnswerIds.push(answer.answer_id)
      })
      return incorrectAnswerIds
    },
    missedQuestions() {
      const { incorrect } = this.finalScore
      return incorrect
    },
  },
  methods: {
    toggleReviewQuestions() {
      this.isReviewingQuestions = !this.isReviewingQuestions
    },
    restartQuiz() {
      this.$emit('restartQuiz')
    },
  },
}
</script>

<style lang="scss" scoped>
.completed {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  &__success-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    min-height: 500px;
    width: 100%;
    max-width: 2400px;
    box-shadow: 6px 0px 50px #0000001a;
    @include desktop {
      width: 80%;
      flex-wrap: nowrap;
      padding: 0 0 0 90px;
    }
  }
  &__icon-wrapper {
    display: none;
    @include desktop {
      display: block;
      padding: 0 50px 0 0;
    }
  }
  &__scorecard {
    width: 75%;
    padding: 0 20px;
    @include desktop {
      width: 50%;
      padding: 0 0 0 50px;
      border-left: 2px solid var(--border-gray);
    }
  }
  &__title {
    text-transform: uppercase;
    font-weight: 700;
    font-size: 32px;
    &--passed {
      color: var(--green);
    }
    &--failed {
      color: var(--purple);
    }
  }
  &__was-successful {
    font-size: 22px;
    font-weight: 700;
    margin: 0 0 20px 0;
    @include desktop {
      font-size: 32px;
    }
  }
  &__score {
    display: flex;
    align-items: center;
    font-size: 32px;
    position: relative;
    &--circle {
      border: 3px solid var(--border-gray);
      border-radius: 100%;
      padding: 30px;
      margin: 5px 10px 10px 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    &--correct {
      position: absolute;
      color: var(--green);
    }
    &--incorrect {
      position: absolute;
      top: 13px;
      color: var(--purple);
    }
    &--text {
      margin: 0;
      padding: 0;
      font-size: 16px;
      @include desktop {
        font-size: 32px;
      }
    }
  }
  &__review-questions-btn {
    font-size: 1rem;
    color: var(--lighter-gray);
    background: transparent;
    border: none;
    margin: 7px 0 0 30px;
    padding: 0 0 1px 0;
    border-bottom: 1px solid var(--lighter-gray);
    cursor: pointer;
  }
  &__retry-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 10%;
    @include desktop {
      flex-direction: row;
    }
  }
  &__retry-text {
    font-size: 22px;
    font-weight: 700;
    margin: 0 10px 15px 0;
    width: 100%;
  }
  &__retry-btn {
    border: none;
    cursor: pointer;
    &:hover {
      opacity: 0.5;
    }
  }
  &__next-video {
    width: 100%;
    display: none;
    @include tablet {
      display: flex;
    }
    @include desktop {
      width: 20%;
    }
  }
  &__review-questions {
    width: 100%;
    @include desktop {
      width: 80%;
    }
  }
}
</style>
